import { BlurPopUpByWord } from "../animations/PopUpAnimations";
import { User, Mail, Send } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import emailjs from "@emailjs/browser";
import { FaSpinner } from "react-icons/fa";
import { MotionDiv } from "../animations/MotionDivWrapper";

const ContactUs = () => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const fullName = (formData.get("fullName") as string)?.trim();
    const email = (formData.get("email") as string)?.trim();
    const message = (formData.get("message") as string)?.trim();

    if (!fullName || !email || !message) {
      toast.error("Please fill out all fields!");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address!");
      return;
    }

    try {
      setLoading(true);

      await emailjs.send(
        "service_fdis4lm",
        "template_ff519wl",
        {
          from_name: fullName,
          from_email: email,
          message,
        },
        "5Rf-TZrCbmiyLD2yb"
      );

      toast.success("Message sent successfully!");
      form.reset();
    } catch (error) {
      console.error("EmailJS Error:", error);
      toast.error("Failed to send message. Please try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="bg-[linear-gradient(to_bottom,rgba(255,255,255,0.05),transparent_40%)] mt-10 lg:mt-32"
      id="contact"
    >
      <div className="container w-full mx-auto py-16 lg:py-28">
        <h2 className="text-center text-3xl uppercase">
          <BlurPopUpByWord text="Get In Touch" />
        </h2>

        <MotionDiv
          direction="up"
          delay={0.2}
          className="bg-black border border-[#28282c] rounded-md p-6 mt-12 space-y-4 max-w-2xl mx-auto"
        >
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <MotionDiv
                direction="up"
                delay={0.3}
                className="flex flex-col gap-1.5"
              >
                <label htmlFor="fullName" className="text-sm">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <User className="absolute left-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" />
                  <input
                    id="fullName"
                    name="fullName"
                    type="text"
                    placeholder="Your name"
                    className="border border-[#28282c] rounded-md px-7 py-2 bg-background text-white text-sm outline-none w-full"
                  />
                </div>
              </MotionDiv>

              <MotionDiv
                direction="up"
                delay={0.4}
                className="flex flex-col gap-1.5"
              >
                <label htmlFor="email" className="text-sm">
                  Email <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <Mail className="absolute left-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" />
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="your.email@example.com"
                    className="border border-[#28282c] rounded-md px-7 py-2 bg-background text-white text-sm outline-none w-full"
                  />
                </div>
              </MotionDiv>
            </div>

            <MotionDiv
              direction="up"
              delay={0.5}
              className="flex flex-col gap-1.5"
            >
              <label htmlFor="message" className="text-sm">
                Message <span className="text-red-500">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                rows={4}
                placeholder="Your message here..."
                className="border border-[#28282c] rounded-md p-2 bg-background text-white text-sm outline-none w-full"
              ></textarea>
            </MotionDiv>

            <MotionDiv direction="up" delay={0.6}>
              <button
                type="submit"
                disabled={loading}
                className="flex items-center gap-1.5 px-4 py-2 bg-white text-black rounded-md text-sm font-medium hover:opacity-80 transition w-full justify-center"
              >
                {loading && <FaSpinner className="animate-spin" />} Send Message
                <Send className="w-3.5 h-3.5" />
              </button>
            </MotionDiv>
          </form>
        </MotionDiv>
      </div>
    </div>
  );
};

export default ContactUs;
